import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "lucky-spin-first-animation"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "git-warp"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "notic-tip"
};
const _hoisted_9 = {
  class: "highlight"
};
const _hoisted_10 = {
  key: 2
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  key: 1,
  class: "envelope-wrap"
};
const _hoisted_13 = {
  key: 0,
  class: "envelope-title"
};
const _hoisted_14 = {
  key: 1,
  class: "envelope-value"
};
const _hoisted_15 = {
  key: 3,
  class: "congratulations-stage"
};
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "congratulations-bg"
}, null, -1);
const _hoisted_17 = ["src"];
const _hoisted_18 = {
  class: "congratulations-title"
};
const _hoisted_19 = {
  class: "congratulations-tip"
};
const _hoisted_20 = {
  class: "highlight"
};
const _hoisted_21 = ["src"];
const _hoisted_22 = ["src"];
import { ref, watch } from 'vue';
import Vue3autocounter from 'vue3-autocounter';
export default {
  __name: 'FirstAnimation',
  props: ['inviteRecord'],
  emits: ['onClose'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const step = ref(1);
    const showBoxStage = ref(true);
    const showSparkling = ref(true);
    const showEnvelopeTitle = ref(false);
    const startAmount = ref(0);
    const endAmount = ref(0);
    const showCongratulations = ref(false);
    const showCoin = ref(false);
    const showMoney = ref(false);
    watch(step, (newValue, oldValue) => {
      if (newValue === 2) {
        setTimeout(() => {
          showBoxStage.value = false;
        }, 300);
        setTimeout(() => {
          showSparkling.value = false;
        }, 2000);
        setTimeout(() => {
          showEnvelopeTitle.value = true;
        }, 2500);
        setTimeout(() => {
          endAmount.value = parseFloat(props.inviteRecord.currentBonus);
        }, 3000);
        setTimeout(() => {
          showCongratulations.value = true;
        }, 6000);
        setTimeout(() => {
          showCoin.value = true;
          showMoney.value = true;
        }, 8000);
        setTimeout(() => {
          showMoney.value = false;
        }, 10000);
        setTimeout(() => {
          emit('onClose');
        }, 11000);
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [showSparkling.value ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        class: "sparkling-gif",
        src: require('@/assets/gif/sparkling.gif')
      }, null, 8, _hoisted_2)) : _createCommentVNode("", true), showBoxStage.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("img", {
        class: "title-gif",
        src: require('@/assets/gif/title.gif')
      }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
        class: "gift-gif",
        src: require('@/assets/gif/gift.gif')
      }, null, 8, _hoisted_6), _createElementVNode("div", {
        class: _normalizeClass(["get-gift-btn", {
          'animation-hide': step.value === 2
        }]),
        onClick: _cache[0] || (_cache[0] = $event => step.value = step.value + 1)
      }, "GET IT NOW", 2), _createElementVNode("img", {
        class: "hand-gif",
        src: require('@/assets/gif/hand-tap.gif')
      }, null, 8, _hoisted_7), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('luckyWheel.noticeSpinTip.tip1').format({
        interval: __props.inviteRecord.extraFreeSpinsInterval
      })), 1), _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('luckyWheel.noticeSpinTip.tip2').format({
        spin: __props.inviteRecord.extraFreeSpins
      })), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t('luckyWheel.noticeSpinTip.tip3')), 1)])])])) : step.value === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [!showCongratulations.value ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        class: "lighitning-gif",
        src: require('@/assets/gif/lighitning.gif')
      }, null, 8, _hoisted_11)) : _createCommentVNode("", true), !showCongratulations.value ? (_openBlock(), _createElementBlock("div", _hoisted_12, [showEnvelopeTitle.value ? (_openBlock(), _createElementBlock("div", _hoisted_13, "The numbe of prices has increase")) : _createCommentVNode("", true), endAmount.value ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createTextVNode("₱ "), _createVNode(_unref(Vue3autocounter), {
        startAmount: startAmount.value,
        endAmount: endAmount.value,
        duration: 2,
        decimals: 2
      }, null, 8, ["startAmount", "endAmount"])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass(["envelope-wrap envelope-bg", !showCongratulations.value ? 'animation-envelope-in' : 'animation-envelope-out'])
      }, null, 2), _createElementVNode("div", {
        class: _normalizeClass(["envelope-btn", !showCongratulations.value ? 'animation-btn-in' : 'animation-btn-out'])
      }, "First time joining", 2), _createElementVNode("div", {
        class: _normalizeClass(["envelope-btn btn-2", !showCongratulations.value ? 'animation-btn-in-2' : 'animation-btn-out-2'])
      }, "A player succesfully withdraw money", 2)])) : _createCommentVNode("", true), showCongratulations.value ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_hoisted_16, _createElementVNode("img", {
        class: "gold-spark-gif",
        src: require('@/assets/gif/gold-spark.gif')
      }, null, 8, _hoisted_17), _createElementVNode("div", {
        class: _normalizeClass(["congratulations-wrap", showCongratulations.value ? 'animation-congratulations-in' : ''])
      }, [_createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('luckyWheel.congratulations')), 1), _createElementVNode("div", _hoisted_19, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('luckyWheel.congratulationTip.tip1')), 1), _createElementVNode("span", _hoisted_20, "₱" + _toDisplayString(__props.inviteRecord.bonus), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t('luckyWheel.congratulationTip.tip2')), 1)])], 2), showCoin.value ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        class: "coin-gif",
        src: require('@/assets/gif/coins.gif')
      }, null, 8, _hoisted_21)) : _createCommentVNode("", true), showMoney.value ? (_openBlock(), _createElementBlock("img", {
        key: 1,
        class: "money-gif",
        src: require('@/assets/gif/money.gif')
      }, null, 8, _hoisted_22)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]);
    };
  }
};